export default "__VITE_ASSET__PVXwD364__"